import { render, staticRenderFns } from "./activity-list.vue?vue&type=template&id=675a822b&scoped=true"
import script from "./activity-list.vue?vue&type=script&lang=js"
export * from "./activity-list.vue?vue&type=script&lang=js"
import style0 from "./activity-list.vue?vue&type=style&index=0&id=675a822b&prod&lang=css"
import style1 from "./activity-list.vue?vue&type=style&index=1&id=675a822b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675a822b",
  null
  
)

export default component.exports